<script setup>
</script>

<template>
  <div class="list-item-content">
    <slot />
  </div>
</template>
